<!--
 * @Author: GeekMzy
 * @Date: 2023-07-11 15:28:51
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\components\Dialog\DialogRhpk.vue
-->
<!-- 排污口详情 -->
<template>
  <div class="dialog-blowdown" style="width: 1024px; min-height: 510px">
    <div class="header">
      <div class="title">{{ data?.name || '-' }}</div>
      <div class="title" @click="showAround">查看周边</div>
    </div>
    <div class="body">
      <div class="content">
        <n-tabs type="line" :on-update:value="onTabChange" animated>
          <n-tab-pane name="jbxx" tab="基本信息">
            <div class="descriptions-group">
              <div class="descriptions-item">
                <span class="key">排污口编码:</span>
                <span class="value">{{ basicData?.pwkbm || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">排污口类型:</span>
                <span class="value">{{ basicData?.pwklx || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">一级分类:</span>
                <span class="value">{{ basicData?.yjfl || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">二级分类:</span>
                <span class="value">{{ basicData?.ejfl || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">所在水系:</span>
                <span class="value">{{ basicData?.pwkszsx || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">受纳水体:</span>
                <span class="value">{{ basicData?.snst || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">执行排放标准:</span>
                <span class="value">{{ basicData?.zxpfbz || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">废水排放量m3/d:</span>
                <span class="value">{{ basicData?.fspflD || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">所在镇街:</span>
                <span class="value">{{ basicData?.szzj || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">是否功能分区:</span>
                <span class="value">{{ basicData?.sfysgnq || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">功能区名称:</span>
                <span class="value">{{ basicData?.ejgnq || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">二级功能区目标:</span>
                <span class="value">{{ basicData?.ejgnqmb || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">经度:</span>
                <span class="value">{{ basicData?.jd || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">纬度:</span>
                <span class="value">{{ basicData?.wd || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">是否纳入整治:</span>
                <span class="value">{{ basicData?.sfnrzz || '-' }}</span>
              </div>
              <!-- <div class="descriptions-item">
                <span class="key">整治措施:</span>
                <span class="value">{{ '-' }}</span>
              </div> -->
              <div class="descriptions-item">
                <span class="key">是否完成整治:</span>
                <span class="value">{{ basicData?.sfwczz || '-' }}</span>
              </div>
              <div class="descriptions-item">
                <span class="key">详细地址:</span>
                <span class="value">{{ basicData?.pwkxxdz || '-' }}</span>
              </div>
            </div>
            <div class="photo_gallary">
              <p>现场照片:</p>
              <img style="max-width: 320px" :src="item" v-for="item in basicData?.xczp" alt="" />
            </div>
          </n-tab-pane>
          <n-tab-pane name="pcxx" tab="排查信息"> 排查信息 </n-tab-pane>
          <n-tab-pane name="jcxx" tab="监测信息">
            <div v-if="isSg" style="max-height: 600px; overflow-y: scroll">
              <div v-for="(item, index) in jcxxSgData" :key="index">
                <div class="descriptions-group">
                  <p>排查时间：{{ item.xccysj || '-' }}</p>
                  <div class="descriptions-item">
                    <span class="key">采样位置:</span>
                    <span class="value">{{ item?.cywz || '-' }}</span>
                  </div>
                  <div class="descriptions-item">
                    <span class="key">采样位置描述:</span>
                    <span class="value">{{ item?.cyxcqkms || '-' }}</span>
                  </div>
                  <div class="descriptions-item">
                    <span class="key">采样方法:</span>
                    <span class="value">{{ item?.cyfs || '-' }}</span>
                  </div>
                  <div class="descriptions-item">
                    <span class="key">监测采样编码:</span>
                    <span class="value">{{ item?.jccybm || '-' }}</span>
                  </div>
                  <div class="descriptions-item">
                    <span class="key">过水断面面积（m2）:</span>
                    <span class="value">{{ item?.gsdmmj || '-' }}</span>
                  </div>
                  <div class="descriptions-item">
                    <span class="key">监测单位名称:</span>
                    <span class="value">{{ item?.jcdw || '-' }}</span>
                  </div>
                  <div class="descriptions-item">
                    <span class="key">是否已建自动监测站:</span>
                    <span class="value">{{ item?.sfyjczdjcz || '-' }}</span>
                  </div>
                  <div class="descriptions-item">
                    <span class="key">是否具备建站条件:</span>
                    <span class="value">{{ item?.sfjbjzdjcztj || '-' }}</span>
                  </div>
                </div>
                <div class="descriptions-item">
                  <span class="key">监测情况</span>
                  <ListTable :tableData="item.tableData" :tableColumns="item.column" :horizontal="true"
                    maxHeight="200px"></ListTable>
                </div>
              </div>
            </div>
            <div v-if="!isSg">
              <div class="auto_top_bar" style="margin-bottom: 10px;">
                <div class="left_bar">执行标准{{ jcxxZdData.zxpfbz }}</div>
                <!-- <div class="right_bar">
                  <n-date-picker v-model:value="dateTime" size="small" type="date" clearable
                    :on-update:formatted-value="fetchJcxxZdData" />
                </div> -->
              </div>
              <div style="display: flex;justify-content: space-between;">
                <div class="tabs">
                  <div class="s-title s-title2" :class="{ 's-title-ac': tabAc === '水质' }" @click="setTab('水质')">水质监测数据
                  </div>
                  <div class="s-title s-title2 ml10" :class="{ 's-title-ac': tabAc === '流量' }" @click="setTab('流量')">
                    流量监测数据
                  </div>
                </div>
                <div class="frequency-box" v-show="tabAc === '水质'">
                  <div class="frequency-btn" :class="{ active: frequencySz === 'R' }" @click="changeFrequencySz('R')">
                    实时
                  </div>
                  <div class="frequency-btn" :class="{ active: frequencySz === 'H' }" @click="changeFrequencySz('H')">
                    小时
                  </div>
                  <div class="frequency-btn" :class="{ active: frequencySz === 'D' }" @click="changeFrequencySz('D')">
                    天
                  </div>
                </div>
                <div class="frequency-box" v-show="tabAc === '流量'">
                  <div class="frequency-btn" :class="{ active: frequencyLl === 'R' }" @click="changeFrequencyLl('R')">
                    实时
                  </div>
                  <div class="frequency-btn" :class="{ active: frequencyLl === 'H' }" @click="changeFrequencyLl('H')">
                    小时
                  </div>
                  <div class="frequency-btn" :class="{ active: frequencyLl === 'D' }" @click="changeFrequencyLl('D')">
                    天
                  </div>
                </div>
              </div>
              <div v-show="tabAc === '水质'">
                <div class="options">
                  <div v-for="(item, index) in factorOptions" :key="index" class="factor"
                    :class="{ active: currentCode === item.factorCode }" @click="handleData(item)">
                    {{ item.factorName }}
                  </div>
                </div>

                <div class="auto_top_bar" style="margin-bottom: 10px;">
                  <div class="left_bar">
                    <n-select style="width: 400px;" v-model:value="activeSzDevice" size="small"
                      :options="szDeviceList" @update:value="changeSzDevice" />
                  </div>
                  <div class="right_bar">
                    <n-date-picker v-show="frequencySz === 'D'" v-model:value="time" size="small" type="month" :on-update:value="onTimeChange"
                      format="yyyy-MM" />
                    <n-date-picker v-show="frequencySz === 'R' || frequencySz === 'H'" v-model:value="time" size="small" type="date" :on-update:value="onTimeChange"
                      format="yyyy-MM-dd" />
                  </div>
                </div>
                <ListTable :tableData="tableDataSz" :tableColumns="columnSz" maxHeight="200px" style="margin-bottom: 10px;">
                </ListTable>
              </div>
              <div v-show="tabAc === '流量'">
                <div class="options">
                  <div v-for="(item, index) in factorOptions2" :key="index" class="factor"
                    :class="{ active: currentCode2 === item.factorCode }" @click="handleData2(item)">
                    {{ item.factorName }}
                  </div>
                </div>

                <div class="auto_top_bar" style="margin-bottom: 10px;">
                  <div class="left_bar">
                    <n-select style="width: 400px;"
                      v-model:value="activeLlDevice" size="small" :options="llDeviceList"
                      @update:value="changeLlDevice" />
                  </div>
                  <div class="right_bar">
                    <n-date-picker v-show="frequencyLl === 'D'" v-model:value="time2" size="small" type="month" :on-update:value="onTimeChange2"
                      format="yyyy-MM" />
                    <n-date-picker v-show="frequencyLl === 'R' || frequencyLl === 'H'" v-model:value="time2" size="small" type="date" :on-update:value="onTimeChange2"
                      format="yyyy-MM-dd" />
                  </div>
                </div>
                <ListTable :tableData="tableDataLl" :tableColumns="columnLl"  maxHeight="200px" style="margin-bottom: 10px;">
                  </ListTable>
              </div>
              <!-- <ListTable style="margin: 14px 0" v-show="jcxxZdData.tableData.length > 0"
                :tableData="jcxxZdData.tableData" :tableColumns="jcxxZdData.column" maxHeight="300px"></ListTable>
              <div v-show="jcxxZdData.tableData.length == 0" style="margin: 10px 0; text-align: center">
                暂无数据
              </div> -->
            </div>
            <div class="bottom_tool">
              <n-button :type="isSg ? 'primary' : 'default'" size="small" @click="onChangeJcType(true)">手工监测</n-button>
              <n-button :type="isSg ? 'default' : 'primary'" size="small" @click="onChangeJcType(false)">自动监测</n-button>
            </div>
          </n-tab-pane>
          <n-tab-pane name="syxx" tab="溯源信息"> 溯源信息 </n-tab-pane>
          <n-tab-pane name="zzxx" tab="整治信息"> 整治信息 </n-tab-pane>
          <n-tab-pane name="jgxx" tab="监管信息"> 监管信息 </n-tab-pane>
          <n-tab-pane name="hzxx" tab="河长信息"> 河长信息 </n-tab-pane>
          <n-tab-pane name="xcxx" tab="巡查信息">
            <div class="wtqd">
              <p>巡查记录</p>
              <n-data-table :data="xcjlList" :columns="xcjlColumns" :bordered="false" :loading="xcjlLoading"
                max-height="240px"></n-data-table>
              <n-modal class="my_deep_dialog" v-model:show="xcxqModal">
                <n-card style="width: auto" :bordered="false" size="huge" role="dialog" aria-modal="true">
                  <div>
                    <span>巡查结论：</span>
                    <span>{{ xcDetail.xcjl || '' }}</span>
                  </div>
                  <div v-if="xcDetail.xcjlImg && xcDetail.xcjlImg.length > 0">
                    <img style="max-width: 200px; height: 100px" v-for="img in xcDetail.xcjlImg" :src="img" alt="" />
                  </div>
                  <div v-else>
                    <p>
                      <span>暂无图片</span>
                    </p>
                  </div>
                </n-card>
              </n-modal>
            </div>
            <div class="wtqd">
              <p>问题清单</p>
              <n-data-table :data="xcwtList" :columns="xcwtColumns" :loading="wtqdLoading" max-height="240px"
                :bordered="false"></n-data-table>
            </div>
          </n-tab-pane>
          <n-tab-pane name="spjk" tab="视频监控">
            <div style="display: flex;">
              <div>
                <n-select style="min-width: 200px;max-width: 320px;margin-bottom: 10px;" v-model:value="activeVideo"
                  size="small" :options="videoList" @update:value="changeVideo" />
                <div ref="videoContainer" class="video-box">
                  <video id="pop_video" style="width: 100%; height: 100%" />
                </div>
              </div>
              <div class="right wtqd" style="padding-left: 10px;">
                <div class="title" style="line-height: 28px; margin-bottom: 10px;">问题清单</div>
                <n-data-table max-height="530" :columns="columns" :data="videoProblemList" :pagination="false"
                  :row-props="problemDetails" :bordered="false" />
              </div>
            </div>
          </n-tab-pane>
        </n-tabs>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, ref, onMounted, onBeforeUnmount, h, nextTick } from 'vue'
import {
  VideoMonitorPointDto,
  CodeReqDto,
  EventListDto,
  PwkBasicRespDto,
  PwkZdjcReqDto,
  Api as SjApi,
  XcjlPageDto,
} from '@/api/screenSj'
import Video from 'video.js'
import { Api as GridApi } from '@/api/grid'
import moment from 'moment'
import ListTable from '@/components/common/ListTable.vue'
import Bus from '@/config/Bus'
import mapService, { BreatheLayer } from '@/utils/mapServices'

const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
const sjApi = new SjApi()
const gridApi = new GridApi()

const activeVideo = ref(null)
const activeSzDevice = ref(null)
const activeLlDevice = ref(null)
const videoList: any = ref([])
const szDeviceList: any = ref([])
const llDeviceList: any = ref([])

const currentCode = ref('')
const currentCode2 = ref('')
const unit = ref('')
const factorName = ref('')
const factorName2 = ref('')
const tabs = ref(['水质', '流量'])
const tabAc = ref('水质')
const factorOptions = ref([])
const factorOptions2 = ref([])
const time = ref(new Date().getTime())
const time2 = ref(new Date().getTime())
const tableDataSz = ref([])
const tableDataLl = ref([])
const columnSz = ref([])
const columnLl = ref([])
const frequencySz = ref('R')
const frequencyLl = ref('R')

const columns = ref([
  {
    title: '序号',
    key: 'no',
    width: 60,
    align: 'center',
    render(row, index) {
      return h(
        `span`,
        {},
        {
          default: () => index + 1,
        }
      )
    },
  },
  {
    title: '时间',
    key: 'reportTimeStr',
    width: 120,
    align: 'center',
  },
  {
    title: '名称',
    key: 'problemName',
    align: 'center',
  },
  {
    title: '状态',
    key: 'problemStatus',
    width: 80,
    align: 'center',
    render(row, index) {
      let className = 'tag dcl'
      if (row.problemStatus === 1) {
        className = 'tag dcl'
      }
      if (row.problemStatus === 2) {
        className = 'tag clz'
      }
      if (row.problemStatus === 3) {
        className = 'tag ywj'
      }
      return h(
        `div`,
        {
          class: className,
        },
        {
          default: () => row.problemStatusStr,
        }
      )
    },
  },
])
const videoProblemList = ref([])

let player: {
  dispose: () => void
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}

//--------------------------------------周边信息-----------------------------------------
const basicData = ref<PwkBasicRespDto | undefined>({})

// 查看排污口周边
function showAround() {
  const params: CodeReqDto = {
    code: data?.value?.id || '',
  }
  sjApi.screen.ckzbUsingPost1(params).then((res) => {
    if (res.data) {
      console.log(res.data, 'res.data')
      const pdata = res.data.self || {}
      const pointData = {
        type: 'FeatureCollection',
        features: [],
      }
      if (pdata.jd && pdata.wd) {
        mapService.removeLayer('pwk')
        const data = {
          id: 0,
          geometry: {
            type: 'Point',
            coordinates: [parseFloat(pdata.jd), parseFloat(pdata.wd)],
          },
          properties: {
            ...pdata,
            name: pdata.name,
            modalType: 'pwk',
            category: 'pwk',
            icon: `重点排水户_0.png`,
            jd: pdata.jd,
            wd: pdata.wd,
          },
          type: 'Feature',
        }
        pointData.features.push(data)
        const breathe = new BreatheLayer('pwk', pointData, ``, 0.7, false)
        breathe.showAnimate(1000, 'Elastic.Out')
        mapService.showLayer(breathe)
        Bus.emit('closeModal')
      }
    }
  })
}

/**
 * @description: 获取基本信息
 * @return {*}
 */
function fetchBasicData() {
  if (data?.value?.id) {
    const parasm: CodeReqDto = {
      code: data.value.id,
    }
    sjApi.screen
      .pwkBasicUsingPost1(parasm)
      .then((res) => {
        if (res.data) {
          basicData.value = res.data
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

/**
 * @description: 获取排查信息
 * @return {*}
 */
function fetchPcxxData() { }

//--------------------------------------监测信息-----------------------------------------
const isSg = ref<boolean>(true)
const jcxxSgData = ref<any[] | undefined>([])
/**
 * @description: 切换监测类型
 * @param {*} bol
 * @return {*}
 */
function onChangeJcType(bol: boolean) {
  isSg.value = bol
  if (bol) {
    fetchJcxxData()
  } else {
    fetchJcxxZdData()
  }
}
/**
 * @description: 获取监测信息
 * @return {*}
 */
function fetchJcxxData() {
  if (data?.value?.id) {
    const params: CodeReqDto = {
      code: data?.value.id,
    }
    sjApi.screen
      .pwksgjcUsingPost1(params)
      .then((res) => {
        if (res.data) {
          jcxxSgData.value = res.data.map((item) => {
            const column: any[] = []
            item.sgjcMonitors?.map((factor) => {
              column.push({
                key: factor.factorCode,
                label: factor.factorName,
                iscb: factor.factorCode + '_cb',
              })
            })
            const tableData: any[] = []
            let monitorRes: any = {}
            item.sgjcMonitors?.map((factor) => {
              if (factor.factorName) {
                monitorRes[factor.factorCode] = factor.monitorValue || '--'
                if(factor.monitorValue && factor.standValue && (factor.monitorValue > factor.standValue)) {
                  monitorRes[factor.factorCode + '_cb'] = true
                }
              }
            })
            
            tableData.push(monitorRes)
            return {
              ...item,
              column,
              tableData,
            }
          })
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
}
const jcxxZdData = ref<any>({})
const dateTime = ref(new Date().getTime())
/**
 * @description: 获取自动监测信息
 * @return {*}
 */
function fetchJcxxZdData() {
  // if (data?.value?.id) {
  //   const params: PwkZdjcReqDto = {
  //     code: data?.value.id,
  //     dateTime: moment(dateTime.value).format('yyyy-MM-DD'),
  //   }
  //   sjApi.screen
  //     .pwkzdjcUsingPost1(params)
  //     .then((res) => {
  //       if (res.data) {
  //         let column: any[] = []
  //         if (res.data?.headers) {
  //           column = res.data?.headers?.map((obj) => {
  //             return {
  //               key: obj.identifier,
  //               label: obj.name + (obj.unit ? '(' + obj.unit + ')' : ''),
  //             }
  //           })
  //         }
  //         jcxxZdData.value.column = column || []
  //         jcxxZdData.value.tableData = res.data.rows || []
  //         jcxxZdData.value.zxpfbz = res.data.zxpfbz || ''
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     })
  // }
  if (data?.value?.id) {
    const params: CodeReqDto = {
      code: data.value.id,
    }
    sjApi.screen.monitorDeviceGroupUsingGET(params).then((res) => {
      if (res.code === 200) {
        let data1 = res.data?.szjcDevices || []
        let data2 = res.data?.llDevices || []
        szDeviceList.value = []
        llDeviceList.value = []
        for (let i = 0; i < data1.length; i++) {
          szDeviceList.value.push(
            {
              label: data1[i].deviceName,
              value: data1[i].deviceCode
            },
          )
        }
        for (let i = 0; i < data2.length; i++) {
          llDeviceList.value.push(
            {
              label: data2[i].deviceName,
              value: data2[i].deviceCode
            },
          )
        }
        activeSzDevice.value = szDeviceList.value[0] ? szDeviceList.value[0].value : ''
        activeLlDevice.value = llDeviceList.value[0] ? llDeviceList.value[0].value : ''
        if (szDeviceList.value.length > 0) {
          changeSzDevice(szDeviceList.value[0].value)
        }
        if (llDeviceList.value.length > 0) {
          changeLlDevice(llDeviceList.value[0].value)
        }
      }
    })
  }
}

function getMonitorDataListPostSz() {
  if(!activeSzDevice.value) {
    return
  }
  let date = new Date(time.value)
  let startTime = new Date(date.setHours(0, 0, 0, 0))
  let endTime
  if (frequencySz.value === 'R' || frequencySz.value === 'H') {
    endTime = new Date(date.setHours(23, 59, 59, 999))
  }
  else {
    startTime = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0)
    endTime = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)
  }
  const params = {
    frequency: frequencySz.value,
    deviceCode: activeSzDevice.value,
    startTime: moment(startTime).format("YYYY-MM-DD HH:mm:ss"),
    endTime: moment(endTime).format("YYYY-MM-DD HH:mm:ss"),
    size: 999
  }
  sjApi.screen.getMonitorDataListPost(params).then((res) => {
    if (res.code === 200) {
      const titleModels: any[] = res.data?.titleModels || []
      // 监测时间列放到最前面
      titleModels.sort((a, b) => (a.factorCode === 'data_time' ? -1 : b.factorCode === 'data_time' ? 1 : 0))
      columnSz.value = titleModels.map((item) => {
        return {
          key: item.factorCode,
          label: item.factorName + (item.unit ? '(' + item.unit + ')' : ''),
          width: item.factorCode === 'data_time' ? '160px' : 'auto',
          // 超标标记，ListTable 中该字段为 true 时数值标红
          iscb: item.factorCode + '_cb',
        }
      })
      tableDataSz.value = (res.data?.monitorDataRespDtos || []).map((dto) => {
        const row: any = { key: dto.data_time?.value }
        titleModels.forEach((item) => {
          const factor = dto[item.factorCode]
          row[item.factorCode] =
            factor && factor.valid !== false && factor.value !== null && factor.value !== undefined
              ? String(factor.value)
              : '--'
          row[item.factorCode + '_cb'] = !!factor?.cb
        })
        return row
      })
    }
  })
}
function getMonitorDataListPostLl() {
  if(!activeLlDevice.value) {
    return
  }
  let date = new Date(time2.value)
  let startTime = new Date(date.setHours(0, 0, 0, 0))
  let endTime
  if (frequencyLl.value === 'R' || frequencyLl.value === 'H') {
    endTime = new Date(date.setHours(23, 59, 59, 999))
  }
  else {
    startTime = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0)
    endTime = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)
  }
  const params = {
    frequency: frequencyLl.value,
    deviceCode: activeLlDevice.value,
    startTime: moment(startTime).format("YYYY-MM-DD HH:mm:ss"),
    endTime: moment(endTime).format("YYYY-MM-DD HH:mm:ss"),
    size: 999
  }
  sjApi.screen.getMonitorDataListPost(params).then((res) => {
    if (res.code === 200) {
      const titleModels: any[] = res.data?.titleModels || []
      // 监测时间列放到最前面
      titleModels.sort((a, b) => (a.factorCode === 'data_time' ? -1 : b.factorCode === 'data_time' ? 1 : 0))
      columnLl.value = titleModels.map((item) => {
        return {
          key: item.factorCode,
          label: item.factorName + (item.unit ? '(' + item.unit + ')' : ''),
          width: item.factorCode === 'data_time' ? '160px' : 'auto',
          // 超标标记，ListTable 中该字段为 true 时数值标红
          iscb: item.factorCode + '_cb',
        }
      })
      tableDataLl.value = (res.data?.monitorDataRespDtos || []).map((dto) => {
        const row: any = { key: dto.data_time?.value }
        titleModels.forEach((item) => {
          const factor = dto[item.factorCode]
          row[item.factorCode] =
            factor && factor.valid !== false && factor.value !== null && factor.value !== undefined
              ? String(factor.value)
              : '--'
          row[item.factorCode + '_cb'] = !!factor?.cb
        })
        return row
      })
    }
  })
}

function changeSzDevice(deviceCodes) {
  activeSzDevice.value = deviceCodes
  getMonitorDataListPostSz()
}

function changeLlDevice(deviceCodes) {
  activeLlDevice.value = deviceCodes
  getMonitorDataListPostLl()
}

/**
 * @description: 获取溯源信息
 * @return {*}
 */
function fetchSyxxData() { }

/**
 * @description: 获取整治信息
 * @return {*}
 */
function fetchZzxxData() { }

/**
 * @description: 获取监管信息
 * @return {*}
 */
function fetchJgxxData() { }

/**
 * @description: 获取河长信息
 * @return {*}
 */
function fetchHzxxData() { }

//--------------------------------------巡查信息-----------------------------------------
const xcjlList = ref<XcjlPageDto[] | undefined>([])
const xcjlColumns: any[] = [
  {
    key: 'wgbh',
    title: '网格编号',
  },
  {
    key: 'hdqd',
    title: '河段起点',
  },
  {
    key: 'hdzd',
    title: '河段终点',
  },
  {
    key: 'xhr',
    title: '巡查人',
  },
  {
    key: 'sbwts',
    title: '上报问题数',
  },
  {
    key: 'xhzt',
    title: '巡河状态',
  },
  {
    key: 'xhkssj',
    title: '巡查开始时间',
  },
  {
    key: 'xhjssj',
    title: '巡查结束时间',
  },
  {
    title: '巡查结果',
    render(row: any) {
      return h(
        'a',
        {
          style: {
            color: '#fff',
          },
          onClick: () => {
            gotoXcDetail(row.id)
          },
        },
        '查看结果'
      )
    },
  },
]
const xcxqModal = ref(false)
const xcDetail = ref<any>({})
/**
 * @description: 巡查详情
 * @param {*} id
 * @return {*}
 */
function gotoXcDetail(id: number) {
  const params = {
    id: id,
  }
  gridApi.openapi
    .xcjlDetailUsingPost(params)
    .then((res) => {
      if (res.data) {
        xcDetail.value.xcjl = res.data.xhResult || '已巡查完成'
        xcDetail.value.xcjlImg = res.data.files
          ?.filter((file) => {
            return file.fileType == 'image'
          })
          .map((item) => {
            return item.url || ''
          })
        xcjlLoading.value = false
        console.log(xcDetail.value)
      }
    })
    .catch((err) => {
      console.log(err)
    })
}
const wtqdLoading = ref(false)
const xcjlLoading = ref(false)
const xcwtList = ref<EventListDto[] | undefined>([])
const xcwtColumns: any[] = [
  {
    key: 'id',
    title: '编号',
  },
  {
    key: 'problemName',
    title: '问题名称',
  },
  {
    key: 'createUser',
    title: '上报人',
  },
  {
    key: 'reportTimeStr',
    title: '上报时间',
  },
  {
    key: 'problemStatusStr',
    title: '处理状态',
  },
  {
    key: 'currentHandleUser',
    title: '当前处理人',
  },
  {
    title: '详情',
    render(row: any) {
      return h(
        'a',
        {
          style: {
            color: '#fff',
          },
          onClick: () => {
            gotoWtDetail(row.id)
          },
        },
        '查看详情'
      )
    },
  },
]
function gotoWtDetail(id: string) {
  Bus.emit('showModal', {
    modalType: '问题详情',
    data: { id: id },
  })
}
/**
 * @description: 获取巡查信息
 * @return {*}
 */
function fetchXcxxData() {
  const params = {
    code: data?.value?.id,
    page: 1,
    pageSize: 100,
  }
  xcjlLoading.value = true
  wtqdLoading.value = true
  sjApi.screen
    .pwkwtqdPageUsingPost1(params)
    .then((res) => {
      if (res.data) {
        xcwtList.value = res.data.items
      }
      wtqdLoading.value = false
    })
    .catch((err) => {
      wtqdLoading.value = false
      console.log(err)
    })
  sjApi.screen
    .pwkxcjlPageUsingPost1(params)
    .then((res) => {
      if (res.data) {
        xcjlList.value = res.data.items
      }
      xcjlLoading.value = false
    })
    .catch((err) => {
      xcjlLoading.value = false
      console.log(err)
    })
}

/**
 * @description: 获取视频监控
 * @return {*}
 */
function fetchSpjkData() {
  if (data?.value?.id) {
    const params: CodeReqDto = {
      code: data.value.id,
    }
    sjApi.screen.monitorDeviceGroupUsingGET(params).then((res) => {
      if (res.code === 200) {
        let data = res.data?.videoDevices || []
        videoList.value = []
        let deviceCodes = []
        for (let i = 0; i < data.length; i++) {
          videoList.value.push(
            {
              label: data[i].deviceName,
              value: data[i].deviceCode
            },
          )
          deviceCodes.push(data[i].deviceCode)
        }

        const params2 = {
          deviceCodes: deviceCodes,
          size: 999
        }
        // sjApi.screen.getVideoProblemListPost(params2).then((res) => {
        //   if (res.code === 200) {
        //     videoProblemList.value = res.data.items
        //   }
        // })

        nextTick(() => {
          const option = {
            muted: false,
            controls: true,
            loop: false,
            autoplay: false,
            sources: [],
            notSupportedMessage: '此视频暂无法播放，请稍后再试',
            // poster:,
            // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
          }
          // 初始化的时候标签默认都是显示的
          player = Video('pop_video', option, () => {
            player.on('error', () => {
              player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
              console.log('视频加载错误')
            })
          })
          activeVideo.value = videoList.value[0].value
          changeVideo(videoList.value[0].value)
        });
      }
    })
  }
}

/**
 * @description: 模块切换回调
 * @param {*} value
 * @return {*}
 */
function onTabChange(value: string | number) {
  console.log('onTabChange', value)
  switch (value) {
    case 'jbxx':
      fetchBasicData()
      break
    case 'pcxx':
      fetchPcxxData()
      break
    case 'jcxx':
      fetchJcxxData()
      break
    case 'syxx':
      fetchSyxxData()
      break
    case 'zzxx':
      fetchZzxxData()
      break
    case 'jgxx':
      fetchJgxxData()
      break
    case 'hzxx':
      fetchHzxxData()
      break
    case 'xcxx':
      fetchXcxxData()
      break
    case 'spjk':
      fetchSpjkData()
      break
    default:
      break
  }
}

const changeVideo = (deviceId) => {
  const params: VideoMonitorPointDto = {
    videoDeviceCode: deviceId,
  }
  sjApi.screen.getVideoStreamGET(params).then((res) => {
    if (res.code === 200) {
      let url = ''
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].videoDeviceCode === deviceId) {
          url = res.data[i].videoStream
          break
        }
      }
      player.src({
        type: '',
        src: url,
      })
      player.play()
    }
  })
}

// 问题详情
const problemDetails = (row: any) => {
  return {
    style: 'cursor: pointer;',
    onClick: () => {
      // Bus.emit('2showModal', {
      //   data: row,
      //   modalType: '问题详情',
      // })
    },
  }
}

const setTab = (val: string) => {
  tabAc.value = val;
  // val === '水质' ? initData() : initData2();
}

const handleData = (val) => {
  currentCode.value = val.factorCode;
  unit.value = val.unit;
  factorName.value = val.factorName;
}
const handleData2 = (val) => {
  currentCode2.value = val.factorCode;
  factorName2.value = val.factorName;
}

const onTimeChange = (val) => {
  time.value = val;
  getMonitorDataListPostSz()
}
const onTimeChange2 = (val) => {
  time2.value = val;
  getMonitorDataListPostLl()
}

const changeFrequencySz = (val: string) => {
  frequencySz.value = val
  getMonitorDataListPostSz()
}
const changeFrequencyLl = (val: string) => {
  frequencyLl.value = val
  getMonitorDataListPostLl()
}

onMounted(() => {
  fetchBasicData()
})

onBeforeUnmount(() => {
  setTimeout(() => {
    player.dispose()
  }, 200)
})
</script>

<style lang="scss" scoped>
.auto_top_bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.dialog-blowdown {
  max-width: 1080px;
  min-width: 53.35rem;

  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;

    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }

  .body {
    .content {
      margin-bottom: 2rem;

      .descriptions-group {
        overflow: hidden;

        h5 {
          font-size: 14px;
          margin: 10px 0;
        }

        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;

          &:last-of-type {
            margin-bottom: 1.4rem;
          }

          .key {
            display: inline-block;
            color: #ffffff;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
      }

      .tabs {
        display: flex;
      }

      .s-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
        height: 30px;
        width: 120px;
        text-align: center;
        line-height: 30px;
      }

      .s-title2 {
        cursor: pointer;
      }

      .s-title-ac {
        background-color: #ffffff;
        color: #0088bf;
      }

      .factor_container {
        height: 4rem;
        overflow: hidden;
        align-items: center;
        line-height: 28px;
        display: flex;

        .options {
          width: 600px;
          display: flex;
        }

        .factor {
          /* display: inline-block; */
          /* min-width: 4rem; */
          padding: 0.2rem 0.5rem;
          text-align: center;
          cursor: pointer;

          &.active {
            background-color: #ffffff;
            color: #0088bf;
          }
        }

        .right-box {
          /* float: right; */
          vertical-align: top;
          display: flex;

          .condition {
            display: flex;

            .echart-btn {
              padding: 0 0.6rem;
              height: 2.65rem;
              line-height: 2.65rem;
              background-color: transparent;
              border: 0.025rem solid #fff;
              color: #fff;
              cursor: pointer;

              &:last-of-type {
                margin-right: 1rem;
              }

              &.active {
                background-color: #ffffff;
                color: #0088bf;
              }
            }
          }

          .font {
            margin: 0 5px;
          }
        }

        :deep(.n-date-picker) {
          float: right;
          width: 120px;
        }
      }

      .frequency-box {
        .frequency-btn {
          width: 5.6rem;
          height: 2.4rem;
          line-height: 2.4rem;
          background: #0088bf;
          border: 0.025rem solid #fff;
          border-radius: 0.1rem;
          text-align: center;
          cursor: pointer;
          display: inline-block;

          &.active {
            background: #fff;
            border: 0.025rem solid #fff;
            color: #0088bf;
          }
        }
      }
    }
  }

  .photo_gallary {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    img {
      max-width: 500px;
    }
  }
}

:deep(.n-data-table .n-data-table-thead) {
  background-color: #ffffff00 !important;
}

:deep(.n-data-table .n-data-table-th) {
  background-color: #ffffff00 !important;
  border-color: #ffffff00 !important;
  border-bottom: #ffffff00 !important;
}

.wtqd {
  :deep(.n-data-table-table) {
    background-color: #2990ca !important;

    .n-data-table-td {
      background-color: #2990ca !important;
      border-bottom: #2990ca !important;
    }

    .n-data-table-thead {
      background-color: #ffffff00 !important;
    }

    .n-data-table-tr {
      background: linear-gradient(180deg,
          rgba(23, 79, 165, 0.6) 0%,
          rgba(135, 178, 231, 0.6) 306.67%);
    }
  }
}

.my_deep_dialog {
  background: #0088bf;
  color: #ffffff;

  :deep(.v-binder-follower-container) {
    .n-popover {
      --n-color: #ffffff !important;
      --n-text-color: #000000 !important;
    }
  }

  .close {
    display: inline-block;
    width: 26px;
    height: 26px;
    line-height: 22px;
    font-size: 30px;
    font-weight: 100;
    background: #0088bf;
    position: absolute;
    top: 0px;
    right: -32px;
    text-align: center;
    cursor: pointer;
  }
}

.video-box {
  width: 57.9rem;
  height: 43rem;
  position: relative;
  background-color: #000;

  #play_window {
    width: 100%;
    height: 100%;
  }

  .video {
    width: 100%;
    height: 100%;

    video {
      width: 100%;
      height: 100%;
    }
  }

  .vjs-modal-dialog-content {
    box-sizing: border-box;
  }

  ::v-deep .vjs-control-text {
    display: none;
  }
}
</style>
